/* eslint-disable react-hooks/exhaustive-deps */
import IconClose from "@mui/icons-material/Close";
import { Dialog, Box, Typography, IconButton, Skeleton } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNews } from "../../../app/slices/newsSlice";
import { translate } from "../../../app/utils";

const Updates = () => {
  const { list, status } = useSelector(({ news }) => news.get);
  const language = localStorage.getItem("currentLanguage")?.toUpperCase();

  const [isOpenNews, setIsOpenNews] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [newsList, setNewsList] = useState();

  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    dispatch(fetchNews({ STATUS: "A", limit: 4 }));
  }, [dispatch]);

  useEffect(() => {
    if (list) {
      let _news = [];

      list?.forEach((item) => {
        _news.push({
          title: item[`TITLE_${language}`],
          description: item[`DESCRIPTION_${language}`],
          datePosted: item?.DATE_CREATED,
          coverImage: item?.COVER_IMAGE,
        });
      });

      setNewsList(_news);
    }
  }, [list, language]);

  //methods
  const reduceParagraph = (s) => {
    if (s?.length > 100) {
      return `${s.substring(0, 99)}...`;
    } else {
      return s;
    }
  };

  //builders
  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
        <Box
          sx={{
            width: { xs: "100%", md: "40%" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            p: { xs: 2, md: 4 },
          }}
        >
          <Typography
            variant="h4"
            fontWeight="800"
            align="center"
            sx={{
              fontSize: { xs: "1.8rem", md: "2.2rem" },
              letterSpacing: 2,
              color: "text.secondary",
              textTransform: "uppercase",
            }}
          >
            {translate("news")} & {translate("updates")}
          </Typography>
        </Box>

        <Box sx={{ width: { xs: "100%", md: "60%" } }}>
          {status === "idle" && newsList !== null && (
            <div
              id="news-updates-container"
              className="flex-row flex-wrap p-10"
              style={{ width: "100%" }}
            >
              {newsList?.map((item) => (
                <div
                  className="news-item"
                  onClick={() => {
                    setSelectedNews(item);
                    setIsOpenNews(true);
                  }}
                >
                  <img src={item?.coverImage} alt="" />
                  <div className="text-container">
                    <div className="title">{item?.title}</div>
                    <div className="description">
                      {reduceParagraph(item?.description)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {status === "loading" && (
            <div
              id="news-updates-container"
              className="flex-row flex-wrap p-10"
              style={{ width: "100%" }}
            >
              {Array.from(new Array(4)).map((_, index) => (
                <div
                  key={index}
                  className="news-item"
                  style={{ overflow: "hidden" }}
                >
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={150}
                    animation="wave"
                  />
                  <div className="text-container" style={{ padding: "10px" }}>
                    <Skeleton
                      variant="text"
                      width="80%"
                      height={24}
                      animation="wave"
                    />
                    <Skeleton
                      variant="text"
                      width="100%"
                      height={16}
                      animation="wave"
                      sx={{ mt: 1 }}
                    />
                    <Skeleton
                      variant="text"
                      width="60%"
                      height={16}
                      animation="wave"
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </Box>
      </Box>

      {/* News Dialog */}
      {isOpenNews && selectedNews != null && (
        <Dialog
          open={isOpenNews}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflow: "hidden",
              m: 2,
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            },
          }}
          onClose={() => {
            setSelectedNews(null);
            setIsOpenNews(false);
          }}
        >
          <Box sx={{ position: "relative" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                bgcolor: "rgba(255,255,255,0.7)",
                backdropFilter: "blur(4px)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.9)" },
                zIndex: 10,
              }}
              onClick={() => {
                setSelectedNews(null);
                setIsOpenNews(false);
              }}
            >
              <IconClose />
            </IconButton>

            <Box
              sx={{
                width: "100%",
                height: { xs: "200px", sm: "300px", md: "400px" },
                position: "relative",
              }}
            >
              <img
                src={selectedNews?.coverImage}
                alt={selectedNews?.title || "News cover"}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "50%",
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%)",
                }}
              />
            </Box>

            <Box sx={{ p: { xs: 3, md: 5 }, bgcolor: "background.paper" }}>
              <Typography
                variant="caption"
                sx={{
                  color: "primary.main",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  display: "block",
                  mb: 1,
                }}
              >
                Posted on:{" "}
                {(() => {
                  if (
                    !selectedNews?.datePosted ||
                    selectedNews.datePosted === "null"
                  )
                    return "Unknown";
                  const isFormatValid = moment(
                    selectedNews.datePosted,
                    "DD-MM-YYYY HH:mm:ss",
                    true,
                  ).isValid();
                  const isStandardValid = moment(
                    selectedNews.datePosted,
                  ).isValid();
                  if (!isFormatValid && !isStandardValid) return "Unknown";
                  return isFormatValid
                    ? moment(
                        selectedNews.datePosted,
                        "DD-MM-YYYY HH:mm:ss",
                      ).format("Do MMM YYYY")
                    : moment(selectedNews.datePosted).format("Do MMM YYYY");
                })()}
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 800,
                  mb: 3,
                  color: "text.primary",
                  lineHeight: 1.2,
                }}
              >
                {selectedNews?.title}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  lineHeight: 1.8,
                  fontSize: "1.05rem",
                  whiteSpace: "pre-line",
                }}
              >
                {selectedNews?.description}
              </Typography>
            </Box>
          </Box>
        </Dialog>
      )}
      {/* News Dialog */}
    </>
  );
};

export default Updates;
